/* eslint-disable */
/**
 * 此处可直接引用自己项目封装好的 axios 配合后端联调
 */

import request from './axios' //组件内部封装的axios
// import request from "@/api/axios.js"       //调用项目封装的axios

//获取验证图片  以及token
export function reqGet(data) {
  return request({
    url: '/biz-gateway/kb-sys-api/digitalUser/getCaptcha',
    method: 'post',
    data,
  })
}

//滑动或者点选验证
export function reqCheck(data) {
  return request({
    url: '/biz-gateway/kb-sys-api/digitalUser/checkCaptcha',
    method: 'post',
    data,
  })
}

// 企业签约
export function companyContract(data) {
  return request({
    url: '/biz-gateway/kb-sys-api/convention/enter',
    method: 'post',
    data,
  })
}

// 校验是否是新用户
export function checkNewUser(data) {
  return request({
    url: '/biz-gateway/kb-sys-api/user/checkUserIsNew',
    method: 'post',
    data,
  })
}
